import React, { Component } from 'react';
import './CircleGraph.scss';

export default class CircleGraph extends Component {

  constructor(props) {
    super(props);

    // This binds all internal functions labled as "handler" to "this"

    for (let name of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (name.toLowerCase().indexOf('handle') >= 0 && (this[name] instanceof Function)) {
        this[name] = this[name].bind(this);
      }
    }
  }

  componentDidMount() {
    this.drawGraph();
  }

  componentDidUpdate(prevProps) {
    this.drawGraph();
  }

  drawGraph() {
    const ctx = this.refs.circleGraph.getContext('2d');
    let { left, top, width, height, percent, color } = this.props;
    if (!left) {
      left = 0;
    }
    if (!top) {
      top = 0;
    }
    const cx = left + (width / 2);
    const cy = top + (height / 2);
    const r = width / 2 - 4;
    
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, 2 * Math.PI);
    ctx.lineWidth = this.props.strokeWidth ? this.props.strokeWidth : 2;
    ctx.strokeStyle = '#bababa';
    ctx.stroke();

    if (percent > 0) {
      ctx.beginPath();
      ctx.arc(cx, cy, r, Math.PI / 2, Math.PI / 2 + (2 * Math.PI * percent), false);
      ctx.lineWidth = this.props.strokeWidth ? this.props.strokeWidth : 2;
      ctx.strokeStyle = color;
      ctx.stroke();
    }  
  } 
  
  render() {
    let { left, top, width, height, position } = this.props;
    if (!left) {
      left = 0;
    }
    if (!top) {
      top = 0;
    }
    if (position == undefined) {
      position = 'absolute';
    }

    let style = {
      left: left + 'px', top: top + 'px', width: (width + 6) + 'px', height: (height + 6) + 'px',
      position: position,
    };
    return (
      <canvas height={height} width={width} style={style} ref="circleGraph">
      </canvas>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/graphics/CircleGraph/index.js